import { LILAC_100, LILAC_800, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getTabsWidgetStyles = (props, tabLayout) => {
  var _minWidthForSingleTabRatio = props.minWidthForSingleTabRatio,
    showAsPills = props.showAsPills;
  var minWidthForSingleTabRatio = _minWidthForSingleTabRatio;
  if (minWidthForSingleTabRatio < 0) minWidthForSingleTabRatio = 0;
  if (minWidthForSingleTabRatio > 1) minWidthForSingleTabRatio = 1;
  var visibleTabs = minWidthForSingleTabRatio ? Math.floor(1 / minWidthForSingleTabRatio) : 1;
  var availableWidth = (tabLayout === null || tabLayout === void 0 ? void 0 : tabLayout.width) ? tabLayout.width - (visibleTabs + 1) * 4 : (tabLayout === null || tabLayout === void 0 ? void 0 : tabLayout.width) || 0;
  var _width = availableWidth / visibleTabs;
  return StyleSheet.create({
    container: Object.assign({
      flexGrow: 0
    }, showAsPills && {
      backgroundColor: LILAC_100,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_12,
      borderColor: LILAC_800,
      borderWidth: 1,
      padding: tokens.spacing.SPACING_4
    }),
    tabContent: Object.assign(Object.assign({}, minWidthForSingleTabRatio > 0 && (tabLayout === null || tabLayout === void 0 ? void 0 : tabLayout.width) && {
      width: showAsPills ? _width : tabLayout.width * minWidthForSingleTabRatio
    }), {
      alignItems: 'center'
    }),
    tab: Object.assign({
      minWidth: showAsPills ? '100%' : 96
    }, !showAsPills && {
      paddingHorizontal: tokens.spacing.SPACING_8
    })
  });
};